import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { IncentiveService } from '../create-incentive/create-incentive.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../loader.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { SharedService } from '../shared/shared.service';
import Utils from '.././utils/utils';
import { defaultStatusMessage } from ".././utils/utils";
import { INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX, IncentiveApprovalRequestsService, } from '../incentive-approval-requests/incentive-approval-requests.service';
import { AuthService } from '../auth.service';
import { AUTHZ_FEATURES } from '../constants/permissions';
import { permissionsForFeature } from '../utils/permission.utils';
import { AlertDialogService } from '../shared/alert-dialog/alert-dialog.service';
import { isLogisticsV2Version } from '../create-incentive/quality-conditions.model';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var ADHOC_TYPE = 'Adhoc';
var OTHERS = 'Others';
var ViewIncentiveComponent = /** @class */ (function () {
    function ViewIncentiveComponent(incentiveService, route, loaderService, router, datePipe, sharedService, approvalRequestsService, authService, alertDialogService, authzAccessHintService) {
        this.incentiveService = incentiveService;
        this.route = route;
        this.loaderService = loaderService;
        this.router = router;
        this.datePipe = datePipe;
        this.sharedService = sharedService;
        this.approvalRequestsService = approvalRequestsService;
        this.authService = authService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.header = 'View Incentive';
        this.incentiveData = {};
        this.userSelectorCount = {};
        this.isMCIncentive = false;
        this.authzAccessHintMessage = '';
        this.authzAccessHintUrl = '';
        this.microCorridorDisplay = '';
        this.isCreateOrDuplicateFlow = true;
        this.goal = [];
        this.state = this.sharedService.STATE.VIEW;
        this.type = "view";
        this.condition = '&&';
        this.userSelectorStatus = tslib_1.__assign({ status: "UNKNOWN" }, defaultStatusMessage);
        this.weeklyIncentiveData = [
            {
                'days': 'All',
                'startDay': { day: 'Monday', index: 1 },
                'endDay': { day: '', index: null }
            }
        ];
        this.dailyIncentiveData = [
            {
                'days': 'All',
            }
        ];
        this.subSetCount = [];
        this.orderChecked = false;
        this.distanceChecked = false;
        this.cancellationChecked = false;
        this.cancellationLimitScope = "";
        this.cancellationGlobalLimit = 0;
        this.setsCancellationLimit = [0];
        this.maxOrderDistanceChecked = false;
        this.maxOrderDistanceGlobal = 0;
        this.qualityChecked = false;
        this.active = true;
        this.qualitativeMetrics = ['APR', 'DPR'];
        this.dailyIncentiveTimeBuckets = environment.incentiveTimeBuckets;
        this.overlappingTimeBuckets = {};
        this.formLoaded = false;
        this.isApprovalPreview = false;
        this.approvalRequestStatus = '';
        this.approvalRequestStatusDisplay = '';
        this.canShowApproveAction = false;
        this.canShowRejectAction = false;
        this.showInsufficientPermissionsMessage = false;
        this.showRequestNotPendingMessage = false;
        this.processingApprovalRequest = false;
        this.currentUserEmail = '';
        this.changedFields = [];
        this.authzAccessHint = null;
        this.back = new EventEmitter();
    }
    ViewIncentiveComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderService.openLoading();
        var incentiveId = this.route.snapshot.paramMap.get('incentiveId');
        this.isApprovalPreview = this.route.snapshot.queryParamMap.get('preview') === 'approval';
        if (this.isApprovalPreview) {
            this.approvalRequestId = incentiveId;
            this.loadApprovalPreviewFromConfigManager(incentiveId);
            return;
        }
        this.incentiveService.getIncentive(incentiveId)
            .subscribe(function (res) {
            _this.applyIncentiveData(res);
        }, function (err) { return console.log(err); });
        this.loadAccessHint();
    };
    ViewIncentiveComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData("incentive")];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewIncentiveComponent.prototype.loadApprovalPreviewFromConfigManager = function (requestId) {
        var _this = this;
        this.approvalRequestsService.fetchApprovalRequestById(requestId)
            .subscribe(function (row) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!row || row.newValue == null) {
                            this.loaderService.closeLoading();
                            console.error('Approval request not found in config-manager for', requestId);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.applyApprovalRequestRow(requestId, row)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var previewData, context;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        previewData = this.readApprovalPreview(requestId);
                        if (!previewData) {
                            this.loaderService.closeLoading();
                            console.error('Approval preview data not found for request', requestId);
                            return [2 /*return*/];
                        }
                        context = this.approvalPreviewContext || { requestId: requestId, newValue: previewData };
                        return [4 /*yield*/, this.applyApprovalRequestRow(requestId, tslib_1.__assign({}, context, { newValue: previewData }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ViewIncentiveComponent.prototype.applyApprovalRequestRow = function (requestId, row) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestStatus, normalized;
            return tslib_1.__generator(this, function (_a) {
                requestStatus = row ? String(row.requestStatus || row.status || '').trim() : '';
                this.approvalPreviewContext = {
                    requestId: requestId,
                    requestStatus: requestStatus,
                    operation: row.operation,
                    createdBy: row.createdBy,
                    resourceId: row.resourceId,
                    resource: row.resource,
                    key: row.key,
                    version: row.version,
                    newValue: row.newValue,
                    oldValue: row.oldValue || null,
                };
                this.approvalRequestStatus = requestStatus;
                normalized = requestStatus.trim().toLowerCase();
                this.approvalRequestStatusDisplay = requestStatus ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : 'Unknown';
                if (row.operation && row.operation.toLowerCase() === 'update' && row.oldValue) {
                    this.computeChangedFields(row.oldValue, row.newValue);
                }
                this.initApprovalPermissions();
                this.applyIncentiveData(row.newValue);
                return [2 /*return*/];
            });
        });
    };
    ViewIncentiveComponent.prototype.readApprovalPreview = function (requestId) {
        var raw = sessionStorage.getItem("" + INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX + requestId);
        if (!raw) {
            return null;
        }
        try {
            var parsed = JSON.parse(raw);
            if (parsed && parsed.newValue != null) {
                this.approvalPreviewContext = parsed;
                return parsed.newValue;
            }
            this.approvalPreviewContext = { requestId: requestId, newValue: parsed };
            return parsed;
        }
        catch (error) {
            return null;
        }
    };
    ViewIncentiveComponent.prototype.initApprovalPermissions = function () {
        var _this = this;
        this.authService.getUserDetails().subscribe(function (user) {
            var incentivePermissions = permissionsForFeature(AUTHZ_FEATURES.INCENTIVE, _this.authService.getAuthzPanels());
            var canApprove = _this.authService.isAuthorizedFor(incentivePermissions.approve, AUTHZ_FEATURES.INCENTIVE);
            var canEdit = _this.authService.isAuthorizedFor(incentivePermissions.edit, AUTHZ_FEATURES.INCENTIVE);
            _this.currentUserEmail = (user && user.email) || '';
            var status = (_this.approvalRequestStatus || '').toLowerCase();
            var isPending = !status || status === 'pending';
            var isCreator = _this.isSamePersonAsRequestCreator();
            _this.canShowApproveAction = canApprove && isPending && !isCreator;
            _this.canShowRejectAction = isPending && (canApprove || (isCreator && canEdit));
            var hasAnyAction = _this.canShowApproveAction || _this.canShowRejectAction;
            if (!hasAnyAction && _this.approvalRequestStatus) {
                _this.showInsufficientPermissionsMessage = isPending;
                _this.showRequestNotPendingMessage = !isPending;
            }
        });
    };
    ViewIncentiveComponent.prototype.isSamePersonAsRequestCreator = function () {
        var creator = this.approvalPreviewContext && this.approvalPreviewContext.createdBy;
        if (!creator || !this.currentUserEmail) {
            return false;
        }
        return (creator || '').trim().toLowerCase() === (this.currentUserEmail || '').trim().toLowerCase();
    };
    ViewIncentiveComponent.prototype.approveIncentiveRequest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isSamePersonAsRequestCreator()) {
                            this.alertDialogService.open({
                                title: 'Cannot approve',
                                message: 'This request cannot be approved by the same person who submitted it. Please ask another approver to review this request.',
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.submitApprovalRequest('approve')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewIncentiveComponent.prototype.rejectIncentiveRequest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.submitApprovalRequest('reject')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewIncentiveComponent.prototype.submitApprovalRequest = function (action) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resource, body, request$, error_1, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.approvalRequestId || this.processingApprovalRequest) {
                            return [2 /*return*/];
                        }
                        this.processingApprovalRequest = true;
                        this.loaderService.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        if (!this.approvalPreviewContext) {
                            throw { error: { message: 'Approval request data is missing. Re-open the request from the list.' } };
                        }
                        resource = this.approvalPreviewContext.resource || 'incentives';
                        body = { resource: resource, comment: action === 'approve' ? 'Approved' : 'Rejected' };
                        request$ = action === 'approve'
                            ? this.approvalRequestsService.approveRequest(this.approvalRequestId, body)
                            : this.approvalRequestsService.rejectRequest(this.approvalRequestId, body);
                        return [4 /*yield*/, request$.toPromise()];
                    case 2:
                        _a.sent();
                        this.alertDialogService.open({
                            title: 'Success',
                            message: action === 'approve'
                                ? 'Incentive approval request was approved successfully.'
                                : 'Incentive approval request was rejected successfully.',
                        });
                        this.canShowApproveAction = false;
                        this.canShowRejectAction = false;
                        this.approvalRequestStatus = action === 'approve' ? 'approved' : 'rejected';
                        this.approvalRequestStatusDisplay = action === 'approve' ? 'Approved' : 'Rejected';
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        message = (error_1 && error_1.error && error_1.error.message)
                            || (error_1 && error_1.error && error_1.error.data && error_1.error.data.error)
                            || (action === 'approve'
                                ? 'Failed to approve incentive request.'
                                : 'Failed to reject incentive request.');
                        this.alertDialogService.open({
                            title: 'Failed',
                            message: message,
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.processingApprovalRequest = false;
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ViewIncentiveComponent.prototype.applyIncentiveData = function (res) {
        var _this = this;
        this.incentiveData = res;
        this.isHHIncentive = this.incentiveData.tags ? this.incentiveData.tags.includes("HH") : false;
        var ap = this.incentiveData.assignmentPolicy;
        this.isMCIncentive = !!(ap && ap.type === 'micro_corridor' && ap.ids && ap.ids[0]);
        this.microCorridorDisplay = this.isMCIncentive
            ? (ap.name && String(ap.name).trim()) || String(ap.ids[0])
            : '';
        this.active = this.incentiveData.active;
        this.findTypeOfIncentive(this.incentiveData);
        this.passGoalsInfo();
        this.formLoaded = true;
        this.loaderService.closeLoading();
        if (!this.isHHIncentive && !this.isMCIncentive && this.incentiveData.ruleId) {
            this.sharedService.getUserSelectorDetails(this.incentiveData.ruleId)
                .subscribe(function (response) {
                _this.userSelectorCount = { count: response.userCount };
            }, function (err) { return console.log(err); });
        }
    };
    ViewIncentiveComponent.prototype.goBack = function () {
        if (this.route.snapshot.queryParamMap.get('preview') === 'approval') {
            this.router.navigate(['/incentive-approval-requests']);
            return;
        }
        this.router.navigate(['/incentives']);
    };
    ViewIncentiveComponent.prototype.isLogisticsV2View = function () {
        return isLogisticsV2Version(this.incentiveData && this.incentiveData.incentiveVersion);
    };
    ViewIncentiveComponent.prototype.deferredPayoutPolicyViewLabel = function () {
        var policy = this.incentiveData && this.incentiveData.payoutPolicy;
        if (!policy) {
            return '';
        }
        return policy.mode || 'MaxDayVsSlots';
    };
    ViewIncentiveComponent.prototype.computeChangedFields = function (oldValue, newValue) {
        var _this = this;
        this.changedFields = [];
        if (!oldValue || !newValue)
            return;
        var fieldLabels = {
            incentiveName: 'Name',
            incentiveDisplayName: 'App Display Name',
            incentiveType: 'Type',
            cities: 'Cities',
            serviceNames: 'Services',
            startDate: 'Start Date',
            endDate: 'End Date',
            priority: 'Priority',
            active: 'Active',
            ruleName: 'User Selector',
            smsTemplate: 'SMS Template',
            tnc: 'Terms & Conditions',
            messageLocale: 'Message Locale',
        };
        Object.keys(fieldLabels).forEach(function (key) {
            var oldVal = oldValue[key];
            var newVal = newValue[key];
            if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
                _this.changedFields.push({
                    field: fieldLabels[key],
                    oldValue: _this.formatValue(oldVal),
                    newValue: _this.formatValue(newVal)
                });
            }
        });
        // Check goals separately for detailed diff
        if (JSON.stringify(oldValue.goals) !== JSON.stringify(newValue.goals)) {
            this.changedFields.push({
                field: 'Goals',
                oldValue: this.parseGoalsForDisplay(oldValue.goals),
                newValue: this.parseGoalsForDisplay(newValue.goals)
            });
        }
    };
    ViewIncentiveComponent.prototype.formatValue = function (val) {
        if (val == null)
            return '-';
        if (Array.isArray(val))
            return val.join(', ');
        if (typeof val === 'object')
            return JSON.stringify(val);
        return String(val);
    };
    ViewIncentiveComponent.prototype.parseGoalsForDisplay = function (goals) {
        if (!goals) {
            return null;
        }
        var sets = [];
        Object.keys(goals).forEach(function (day) {
            goals[day].forEach(function (goal, idx) {
                var timeSlots = goal.timeSlot && goal.timeSlot.length
                    ? goal.timeSlot.map(function (ts) { return ts.fromTime + '-' + ts.toTime; }).join(', ')
                    : '-';
                var rules = goal.rules
                    ? goal.rules.map(function (r) { return ({
                        orders: r.order,
                        amount: r.amount
                    }); })
                    : [];
                sets.push({
                    setNumber: idx + 1,
                    timeSlot: timeSlots,
                    rules: rules
                });
            });
        });
        return sets;
    };
    ViewIncentiveComponent.prototype.findTypeOfIncentive = function (defaultValue) {
        if (defaultValue && (defaultValue.incentiveType === 'Daily'
            || defaultValue.incentiveType === 'Adhoc')) {
            this.getDailyIncentiveData(this.incentiveData);
        }
        else {
            this.getWeeklyIncentiveData(this.incentiveData);
        }
    };
    ViewIncentiveComponent.prototype.getWeeklyIncentiveData = function (defaultValue) {
        this.condition = defaultValue.selectedCondition;
        var incentives = [];
        var formattedWeeklyincentiveData;
        Object.keys(defaultValue.goals).forEach(function (goalInDays, index) {
            formattedWeeklyincentiveData = {};
            formattedWeeklyincentiveData['days'] = goalInDays;
            var weekDays = goalInDays.split(',');
            formattedWeeklyincentiveData['startDay'] = { day: weekDays[0].trim(), index: Utils.findIndexOfDay(weekDays[0]) };
            formattedWeeklyincentiveData['endDay'] = {
                day: weekDays[weekDays.length - 1].trim(),
                index: Utils.findIndexOfDay(weekDays[weekDays.length - 1])
            };
            var weekWiseIncentive = defaultValue.goals[goalInDays];
            weekWiseIncentive.map(function (incentive) {
                incentive.timeSlot = incentive.timeSlot.map(function (slot) {
                    return {
                        fromTime: Utils.timeToTimeStamp(slot.fromTime),
                        toTime: Utils.timeToTimeStamp(slot.toTime),
                    };
                });
            });
            var incentiveStartDate = new Date(defaultValue.startDate).getTime();
            var currentDate = new Date().getTime();
            var t = Math.round(currentDate - incentiveStartDate) / (1000 * 60 * 60 * 24);
            if ((t) >= 7) {
                formattedWeeklyincentiveData['disabled'] = true;
            }
            else if (t <= 6 && t >= 0) {
                if (formattedWeeklyincentiveData['startDay'].index <= new Date().getUTCDay()) {
                    formattedWeeklyincentiveData['disabled'] = true;
                }
            }
            weekWiseIncentive.forEach(function (incentive, index) {
                var weeklyIndex = incentives.length;
                formattedWeeklyincentiveData[weeklyIndex] = incentive;
                incentives.push(formattedWeeklyincentiveData);
            });
        });
        this.weeklyIncentiveData = incentives;
    };
    ViewIncentiveComponent.prototype.getDailyIncentiveData = function (defaultValue) {
        var _this = this;
        var incentives = [];
        this.condition = defaultValue.selectedCondition;
        ;
        var formattedDailyincentiveData = {
            'days': 'All',
        };
        Object.keys(defaultValue.goals).forEach(function (goalInDays, index) {
            var dayWiseIncentive = defaultValue.goals[goalInDays];
            dayWiseIncentive.map(function (incentive) {
                incentive.timeSlot = incentive.timeSlot.map(function (slot) {
                    return {
                        fromTime: Utils.timeToTimeStamp(slot.fromTime),
                        toTime: Utils.timeToTimeStamp(slot.toTime),
                    };
                });
            });
            dayWiseIncentive.forEach(function (incentive, index) {
                formattedDailyincentiveData[index + 1] = incentive;
            });
        });
        defaultValue.selectedVariable.forEach(function (variable) {
            switch (variable) {
                case 'order': {
                    _this.orderChecked = true;
                    break;
                }
                case 'distance': {
                    _this.distanceChecked = true;
                    break;
                }
                case 'quality': {
                    _this.qualityChecked = true;
                    break;
                }
                case 'cancellation': {
                    _this.cancellationChecked = true;
                }
                case 'maxOrderDistance': {
                    _this.maxOrderDistanceChecked = true;
                }
            }
            var goalsKey = Object.keys(defaultValue.goals)[0];
            _this.setsCancellationLimit = [];
            _this.cancellationGlobalLimit = defaultValue.cancellationLimit;
            _this.maxOrderDistanceGlobal = defaultValue.maxOrderDistance;
            for (var _i = 0, _a = defaultValue.goals[goalsKey]; _i < _a.length; _i++) {
                var set = _a[_i];
                _this.setsCancellationLimit.push(set.cancellationLimit);
            }
            if (_this.cancellationChecked) {
                if (defaultValue.cancellationLimit != 0) {
                    _this.cancellationLimitScope = "global";
                }
                else {
                    _this.cancellationLimitScope = "set";
                }
            }
        });
        this.dailyIncentiveData = [formattedDailyincentiveData];
    };
    ViewIncentiveComponent.prototype.passGoalsInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var goalsInfo, details;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        goalsInfo = {};
                        if (this.incentiveData.incentiveType === 'Daily'
                            || this.incentiveData.incentiveType === 'Adhoc') {
                            if (this.incentiveData.incentiveType === 'Daily') {
                                goalsInfo['cancellationLimitScope'] = this.cancellationLimitScope;
                                goalsInfo['cancellationLimit'] = this.cancellationGlobalLimit;
                                goalsInfo['cancellationChecked'] = this.cancellationChecked;
                                goalsInfo['setsCancellationLimit'] = this.setsCancellationLimit;
                            }
                            if (this.incentiveData.incentiveType === 'Adhoc') {
                                goalsInfo['maxOrderDistanceGlobal'] = this.maxOrderDistanceGlobal;
                                goalsInfo['maxOrderDistanceChecked'] = this.maxOrderDistanceChecked;
                            }
                            goalsInfo['dailyIncentiveData'] = this.dailyIncentiveData;
                        }
                        else if (this.incentiveData.incentiveType === 'Weekly Fixed') {
                            goalsInfo['weeklyIncentiveData'] = this.weeklyIncentiveData;
                        }
                        else {
                            goalsInfo['weeklyIncentiveData'] = this.weeklyIncentiveData;
                        }
                        goalsInfo['selectedVariable'] = this.incentiveData.selectedVariable;
                        goalsInfo['selectedCondition'] = this.incentiveData.selectedCondition;
                        this.incentiveData['goalsInfo'] = goalsInfo;
                        if (!this.incentiveData) return [3 /*break*/, 2];
                        this.header = 'View - ' + this.incentiveData.incentiveType + ' incentive - ' +
                            this.datePipe.transform(this.incentiveData.startDate, 'd MMMM yy')
                            + ' to ' + this.datePipe.transform(this.incentiveData.endDate, 'd MMMM yy');
                        return [4 /*yield*/, Utils.fetchUserSelectorStatus(this.type, this.userSelectorId, this.incentiveData, this.userSelectorStatus, this.sharedService)];
                    case 1:
                        details = _a.sent();
                        if (details !== undefined) {
                            this.userSelectorStatus = details.userSelectorStatus;
                            this.userSelectorId = details.userSelectorId;
                        }
                        _a.label = 2;
                    case 2:
                        if (this.incentiveData.goalsInfo && this.incentiveData.goalsInfo.dailyIncentiveData) {
                            this.dailyData = _.cloneDeep(this.incentiveData.goalsInfo.dailyIncentiveData);
                        }
                        if (this.incentiveData.goalsInfo && this.incentiveData.goalsInfo.weeklyIncentiveData) {
                            this.dailyData = _.cloneDeep(this.incentiveData.goalsInfo.weeklyIncentiveData);
                        }
                        this.goal = Utils.organizeData(this.type, this.incentiveData, this.dailyData, this.datePipe, this.variables);
                        return [2 /*return*/];
                }
            });
        });
    };
    return ViewIncentiveComponent;
}());
export { ViewIncentiveComponent };
